import { getMetadata } from '@portal/services/metadata';

import { getInstance } from '@portal/repositories/securitySdkConfig';
import {
  ICheckPin,
  TotpTokenRequestParams,
  TotpTransferParams,
} from '@portal/models/enumerators/totp';
import { Transaction } from '../models/bank';

const BASE_URL = '/transaction';
const TotpApi = {
  checkPin: async (authenticate: ICheckPin): Promise<void> => {
    const metadata = await getMetadata();
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/check-pin`, {
      authenticate,
      metadata,
    });
    return data;
  },

  requestToken: async (params: TotpTokenRequestParams): Promise<void> => {
    const metadata = await getMetadata();
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/token-request`, {
      ...params,
      metadata,
    });
    return data;
  },

  totpTransfer: async (params: TotpTransferParams): Promise<Transaction> => {
    const metadata = await getMetadata();
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/totp-transfer`, {
      ...params,
      metadata,
    });
    return data;
  },
};
export default TotpApi;
